import { useMutation } from '@tanstack/react-query';

import { profileTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const addProfilePage: profileTypes.AddProfilePage = (data) => {
  return axios.post(`/profile/page`, data);
};

type UseAddProfilePageOptions = {
  config?: MutationConfig<typeof addProfilePage>;
};

export function useAddProfilePage({ config = {} }: UseAddProfilePageOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['profiles']);
      config.onSuccess && config.onSuccess(...params);
    },
    mutationFn: addProfilePage,
  });
}
